import React from 'react';
import { Button, Col, Row, Space, Typography } from 'antd';
import UsageLimit, { UsageLimits } from '../../UsageLimits/usage-limits';

type FirstStepProps = {
  goToNext: () => void;
  goToPrevious: () => void;
  usageLimit: UsageLimits;
  setUsageLimit: (value: UsageLimits) => void;
};

const FourthStep: React.FC<FirstStepProps> = ({ goToNext, goToPrevious, usageLimit, setUsageLimit }) => {

  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <Typography.Title level={3}>Seleccionar limitador de uso</Typography.Title>
        </Col>
      </Row>
      <UsageLimit
        usageLimit={ usageLimit }
        setUsageLimit={ setUsageLimit }
        action={'view'}
      />
      <Col span={32} style={{ textAlign: 'center', marginTop: '40px' }} >
        <Space>
          <Button onClick={ goToPrevious } >
            Anterior
          </Button>
          <Button type="primary" onClick={ goToNext } >
            Siguiente
          </Button>
        </Space>
      </Col>
    </>
  )
}

export default FourthStep;